import { reportError } from "@cabocheck/shared";
import type { LoaderFunctionArgs } from "react-router";
import { redirect } from "react-router";
import { useLoaderData } from "react-router";
import invariant from "invariant";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { client } from "~/client/client";
import { ProductsHeader } from "~/features/microsite/ProductsHeader";
import { TestOffersComponent } from "~/features/microsite/TestOffers";
import { PublicFooter } from "~/features/public/Footer";
import { MedicalTestProfileBox } from "~/features/tests/MedicalTestProfileBox";
import { smallerSortFirst } from "~/utils/apis/getMedicalTestProfilesList";
import { getBaseParams } from "~/utils/getBaseParams";

export async function loader({ request, params }: LoaderFunctionArgs) {
  const { slug } = params;
  invariant(slug, "slug is required");
  const { data: responseData, error } = await client.v1.getApiPartnerLandingByCode({
    ...(await getBaseParams(request, { withDeviceGuid: false })),
    code: slug,
  });

  if (error) reportError("Products request failed", error);

  if (!responseData?.response) {
    return redirect("/");
  }

  return {
    ...responseData.response,
    medical_test_profiles: responseData.response.medical_test_profiles
      ?.filter((profile) => profile.selling_price != null)
      .sort(smallerSortFirst),
  };
}

export default function PharmacyHome() {
  const { t } = useTranslation();
  const data = useLoaderData<typeof loader>();
  const [filter, setFilter] = useState("");

  return (
    <div id="angebot">
      <div className="h-28" />
      <TestOffersComponent
        header={<ProductsHeader filter={filter} setFilter={setFilter} />}
        products={data.medical_test_profiles
          ?.filter((p) => p.name.toLowerCase().includes(filter.toLowerCase()))
          .map((p) => (
            <MedicalTestProfileBox
              key={p.medical_test_profile_guid}
              to={`${p.name}`}
              panel={{
                name: p.name,
                subline: p.subline,
                selling_price: p.selling_price,
                medical_tests: p.medical_tests,
              }}
            />
          ))}
        emptyContent={filter ? <p className="text-center text-gray-600">{t("Keine Daten gefunden")}</p> : undefined}
      />
      <PublicFooter />
    </div>
  );
}
